//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  resource,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";

// local imports
import { CatalogConstants, CatalogStateService, DocumentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";
import { Messenger } from "@app/shared";

@Component({
  selector: "project-property",
  standalone: false,
  templateUrl: "./project-property.component.html",
  styleUrl: "./project-property.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectPropertyComponent {
  private route = inject(ActivatedRoute);
  private catalogStateService = inject(CatalogStateService);

  public catalogConstants = CatalogConstants;

  public projectPropertyResource = resource({
    request: () => ({
      id: this.route.snapshot.paramMap.get("id"),
      departmentId: this.route.snapshot.queryParamMap.get(
        CatalogCommonConstants.ROUTE_PARAMS.DEPARTMENT_ID
      ),
      programId: this.route.snapshot.queryParamMap.get(
        CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID
      ),
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getProjectProperty(
        request.id
      );

      if (property.documents) {
        const filteredDocuments = property.documents().filter(
          (doc: DocumentModel) => !doc.superseded()
        );
        property.documents.set(filteredDocuments);
      }

      return property;
    },
  });
}